/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Availability
 *
 * 1 = PartExchange
 *
 * 2 = FailedFinance
 *
 * 3 = BoughtElsewhere
 *
 * 4 = ChangedMind
 *
 * 5 = PriceFigures
 *
 * 6 = VehicleCondition
 *
 * 7 = LackContact
 *
 * 8 = Duplicate
 *
 * 9 = SystemCleansing
 */
export enum StatusReasonsEnum {
  Availability = 0,
  PartExchange = 1,
  FailedFinance = 2,
  BoughtElsewhere = 3,
  ChangedMind = 4,
  PriceFigures = 5,
  VehicleCondition = 6,
  LackContact = 7,
  Duplicate = 8,
  SystemCleansing = 9,
}
